import { Document, Folder } from '@quadminds/client-apis/agents';
import moment from 'moment';
import { FileItem, FileStatus } from '../../types/File/File.types';

export const documentToFile = (document: Document): FileItem => {
    // Safely parse the updated_at date with fallback
    let modifiedAt: Date;
    try {
        modifiedAt = document.updated_at ? moment(document.updated_at).toDate() : new Date();
    } catch (e) {
        modifiedAt = new Date();
    }

    // Handle modifiedBy based on uploaded_by type
    let modifiedBy = 'Unknown';
    if (typeof document.uploaded_by === 'string') {
        modifiedBy = document.uploaded_by;
    } else if (document.uploaded_by && typeof document.uploaded_by === 'object') {
        modifiedBy = document.uploaded_by.fullName || document.uploaded_by.userId || 'Unknown';
    }

    return {
        id: document._id || document.id || '',
        name: document.name || document.filename || '',
        type: 'file',
        size: typeof document.size === 'number' ? document.size : 0,
        modifiedAt,
        path: document.name || document.filename || '',
        summary: document.summary || '-',
        comments: '',
        active: document.active ?? true,
        status: (document.status || 'uploaded') as FileStatus,
        modifiedBy,
        uploaded_by:
            document.uploaded_by && typeof document.uploaded_by === 'object'
                ? {
                      userId: document.uploaded_by.userId,
                      fullName: document.uploaded_by.fullName,
                      photo: document.uploaded_by.photo || '',
                  }
                : undefined,
        // Check both tags (from Document) and topics (from RequestDTO)
        topics: document.tags || [],
        parentId: document.parent_id || null,
        // ✅ Acceso directo usando indexación
        document_permissions: (document as any).document_permissions || [],
    };
};

export const documentToFolder = (document: Folder): FileItem => {
    // Safely parse the updated_at date with fallback
    let modifiedAt: Date;
    try {
        modifiedAt = document.updated_at ? moment(document.updated_at).toDate() : new Date();
    } catch (e) {
        modifiedAt = new Date();
    }

    // Handle modifiedBy based on uploaded_by type
    let modifiedBy = 'Unknown';
    if (typeof document.uploaded_by === 'string') {
        modifiedBy = document.uploaded_by;
    } else if (document.uploaded_by && typeof document.uploaded_by === 'object') {
        modifiedBy = document.uploaded_by.fullName || document.uploaded_by.userId || 'Unknown';
    }

    return {
        id: document.id || '',
        name: document.name || '',
        type: 'folder',
        size: null,
        modifiedAt,
        path: document.name || '',
        summary: '-',
        comments: '',
        modifiedBy,
        active: true,
        status: 'uploaded' as FileStatus,
        parentId: document.parent_id || null,
        // ✅ Acceso directo usando indexación
        document_permissions: (document as any).document_permissions || [],
    };
};
